module.exports = __webpack_public_path__ + "static/media/sort-numeric-down.23ae5dd7.svg";